// Po odeslání z domovské stránky se pole animovaně přesune dolů (FLIP mezi obrazovkami).
let lastRect: DOMRect | null = null;

export function rememberComposerRect(r: DOMRect | null) {
  lastRect = r;
}

export function playComposerMove(el: HTMLElement | null, reduce: boolean) {
  const first = lastRect;
  lastRect = null;
  if (!first || !el || reduce) return;
  const last = el.getBoundingClientRect();
  const dy = first.bottom - last.bottom;
  const dx = first.left - last.left;
  if (Math.abs(dy) < 3) return;
  el.style.transition = 'none';
  el.style.transform = `translate(${dx}px, ${dy}px)`;
  void el.offsetHeight;
  requestAnimationFrame(() => {
    el.style.transition = 'transform 0.55s cubic-bezier(0.22, 0.9, 0.24, 1)';
    el.style.transform = '';
    setTimeout(() => (el.style.transition = ''), 600);
  });
}
